import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardHeader from "../../components/Other/DashboardHeader";
import PageContainer from "../../components/pages/PageContainer";
import PageHeader from "../../components/PageHeader";

// Step Components
import Step1SelectVibe from "./Step1SelectVibe";
import Step2LinkVibe from "./Step2LinkVibe";
import Step3Categories from "./Step3Categories";
import Step4Venues from "./Step4Venues";
import Step5DateTime from "./Step5DateTime";
import Review from "./Review";
import { useTranslation } from "react-i18next";
import CustomPageHeader from "../../components/pages/CustomPageHeader";

const CreateVibe = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Read ?step= from URL
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const initialStep = parseInt(query.get("step")) || 1;

  const [step, setStep] = useState(initialStep);

  const [formData, setFormData] = useState(() => {
    const initialDate = location.state?.selectedDate || "";
    
    return {
      vibeName: "",
      vibeType: "", // Favorites / Poll
      selectedVibe: "",
      vibeList: ["Game Watch", "Dinner Dates", "Watch Movie"],

      category: "",
      distance: "",
      address: "",
      selectedPlace: "",
      date: initialDate, // Pre-fill with selected date from calendar
      time: "",
      
      // Store the original selectedDate so it doesn't get lost
      originalSelectedDate: location.state?.selectedDate || null,

      // extra notes handled in Step6
    };
  });

  // Ensure selectedDate from calendar is properly set when component mounts
  useEffect(() => {
    if (location.state?.selectedDate && !formData.date) {
      setFormData(prev => ({ ...prev, date: location.state.selectedDate }));
    }
  }, [location.state?.selectedDate, formData.date]);

  const goNext = () => setStep((prev) => prev + 1);
  const goBack = () => {
    if (step === 1) {
      // If on step 1, navigate to home page instead of going to step 0
      navigate('/home');
    } else {
      setStep((prev) => prev - 1);
    }
  };
  const skipToStep = (targetStep) => setStep(targetStep);
  const finishWizard = () => {
    // after sending vibe - redirect to calendar page
    // window.location.href = "/calendar";
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1SelectVibe
            formData={formData}
            setFormData={setFormData}
            goNext={goNext}
            goBack={goBack}
          />
        );
      case 2:
        return (
          <Step2LinkVibe
            formData={formData}
            setFormData={setFormData}
            goBack={goBack}
            goNext={goNext}
          />
        );
      case 3:
        return (
          <Step3Categories
            formData={formData}
            setFormData={setFormData}
            goBack={goBack}
            goNext={goNext}
            skipToStep={skipToStep}
          />
        );
      case 4:
        return (
          <Step4Venues
            formData={formData}
            setFormData={setFormData}
            goBack={goBack}
            goNext={goNext}
          />
        );
      case 5:
        return (
          <Step5DateTime
            formData={formData}
            setFormData={setFormData}
            goBack={goBack}
            goNext={goNext}
          />
        );
      case 6:
        return (
          <Review
            formData={formData}
            setFormData={setFormData}
            goBack={goBack}
            onFinish={finishWizard}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <CustomPageHeader
        showPageHeaderBackButton={false}
    pageContainerInnerClass="p-4"
 
        showPageHeader={false}
        pageContainerClass="px-2 "
        title={t("create_your_vibe", "Create Your Vibe")}
      >
        {/* <div className="flex justify-end items-center mb-6 w-full ">
          <span className="text-black font-semibold">Step {step} of 6</span>
        </div> */}

       <div className="py-4"> 
         {renderStep()}
       </div>
      </CustomPageHeader>
    </>
  );
};

export default CreateVibe;
